import React, { Component } from 'react'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import { renderTextField, renderDateMaterialField } from '../../Forms/fieldRenderers'
import { required } from '../../Forms/fieldValidators'
import { Button } from 'react-bootstrap'
import { TextField, FormControlLabel, Switch } from '@material-ui/core'
import { FORM_TAREA_MOVIMIENTO } from '../../../config/forms'
import { connect } from 'react-redux'
import moment from 'moment'
import { toast } from 'react-toastify'
import * as actions from '../actions'
import SelectTarea from './SelectTarea'

const selector = formValueSelector(FORM_TAREA_MOVIMIENTO)

class FormTareaMovimiento extends Component {
  constructor (props) {
    super(props)
    this.changeFechaInicio = this.changeFechaInicio.bind(this)
    this.changeHoraInicio = this.changeHoraInicio.bind(this)
    this.changeFechaFin = this.changeFechaFin.bind(this)
    this.changeHoraFin = this.changeHoraFin.bind(this)
    this.changeTarea = this.changeTarea.bind(this)
    this.changeToneladas = this.changeToneladas.bind(this)
    this.showFinalizarTarea = this.showFinalizarTarea.bind(this)
    this.submitTarea = this.submitTarea.bind(this)
    this.resetState = this.resetState.bind(this)
    this.state = { tareaFinalizada: false }
  }

  componentDidMount () {
    const {
      change: formChange,
      fechaInicio,
      horaInicio
    } = this.props

    this.setState({ tareaFinalizada: false })
    moment.locale()
    if (!horaInicio) { formChange('horaInicio', (moment().format('HH:mm:ss'))) }
    if (!fechaInicio) { formChange('fechaInicio', (moment().format('YYYY/MM/DD'))) }
  }

  showFinalizarTarea () {
    const { change: formChange, tarea } = this.props
    if (tarea) {
      this.setState({ tareaFinalizada: !this.state.tareaFinalizada })
      const fechaFinalizacionDefault = moment().format('YYYY/MM/DD')
      const horaFinalizacionDefault = moment().format('HH:mm:ss')
      formChange('fechaFin', fechaFinalizacionDefault)
      formChange('horaFin', horaFinalizacionDefault)
    } else {
      toast.error('Primero debe seleccionar una tarea.')
    }
  }

  changeFechaInicio (f) {
    const { change: formChange } = this.props
    const fecha = moment(f).format('YYYY-MM-DD')
    formChange('fechaInicio', fecha)
  }

  changeHoraInicio (e) {
    const { change: formChange } = this.props
    formChange('horaInicio', e.target.value)
  }

  changeFechaFin (f) {
    const { change: formChange } = this.props
    const fecha = moment(f).format('YYYY-MM-DD')
    formChange('fechaFin', fecha)
  }

  changeHoraFin (e) {
    const { change: formChange } = this.props
    formChange('horaFin', e.target.value)
  }

  changeTarea (tarea) {
    const { change: formChange } = this.props
    formChange('tarea', tarea)
  }

  changeToneladas (toneladas) {
    const { change: formChange } = this.props
    formChange('toneladas', toneladas)
  }

  resetState () {
    const { change: formChange } = this.props
    this.setState({ tareaFinalizada: false })
    moment.locale()
    formChange('horaInicio', (moment().format('HH:mm:ss')))
    formChange('fechaInicio', (moment().format('YYYY/MM/DD')))
    formChange('tarea', '')
    formChange('tonedalas', '')
  }

  submitTarea () {
    const { handleSubmit, toneladas } = this.props
    if (this.state.tareaFinalizada && !toneladas) {
      toast.error('Debe ingresar las toneladas.')
    } else {
      handleSubmit(this.state.tareaFinalizada)
      this.resetState()
    }
  }

  render () {
    const { tareas, tarea, horaInicio } = this.props

    return (

      <div className='container-form-tareas'>
        <div className='div-form-tareas'>
          <Field
            autoOk
            name='fechaInicio'
            emptyLabel
            component={renderDateMaterialField}
            autoFocus={false}
            validate={[required]}
            helperText='Inicio de tarea'
            onChange={(f) => { this.changeFechaInicio(f) }}
            placeholder={``}
          />
          <form noValidate>
            <TextField
              style={{ marginBottom: '40%' }}
              id='time'
              name='horaInicio'
              type='time'
              defaultValue={horaInicio || moment().format('HH:mm')}
              label=''
              onChange={(h) => { this.changeHoraInicio(h) }}
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                step: 300 // 5 min
              }}
            />
          </form>
        </div>
        <div className='div-form-tareas div-select-tarea'>
          <SelectTarea tarea={tarea} tareas={tareas} changeForm={this.changeTarea} style={{ width: '60%' }} />
          <div style={{ width: '35%' }} >
            <p style={{ marginBottom: '0' }}>Tarea finalizada</p>
            <FormControlLabel key='tareafinalizada' control={<Switch
              color='primary'
              name='Tarea finalizada'
              onClick={this.showFinalizarTarea}
              checked={this.state.tareaFinalizada}
            />}
            />
          </div>
        </div>

        { this.state.tareaFinalizada && <div style={{ width: '100%' }}>
          <div className='div-form-tareas'>
            <Field
              autoOk
              emptyLabel
              name='fechaFin'
              component={renderDateMaterialField}
              autoFocus={false}
              validate={[required]}
              helperText='Finalización de tarea'
              onChange={(f) => { this.changeFechaFin(f) }}
              placeholder={``}
            />
            <form noValidate>
              <TextField
                style={{ marginBottom: '40%' }}
                id='time'
                type='time'
                defaultValue={moment().format('HH:mm')}
                label=''
                onChange={(h) => { this.changeHoraFin(h) }}
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{
                  step: 300 // 5 min
                }}
              />
            </form>
          </div>
          <div className='form-toneladas-tareas'>
            <Field
              name='toneladas'
              component={renderTextField}
              label='Toneladas'
              onChange={(t) => { this.changeToneladas(t) }}
            />
          </div>
        </div>
        }

        <Button
          className='btn-preingreso'
          type='submit'
          size='lg'
          onClick={() => this.submitTarea()}
        >Confirmar</Button>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    tarea: selector(state, 'tarea'),
    fechaInicio: selector(state, 'fechaInicio'),
    horaInicio: selector(state, 'horaInicio'),
    fechaFin: selector(state, 'fechaFin'),
    horaFin: selector(state, 'horaFin'),
    toneladas: selector(state, 'toneladas'),
    tareas: state.cuadroDeMandoMovimientos.tareasMovimiento,
    tareaInicial: state.cuadroDeMandoMovimientos.tareaInicial
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_TAREA_MOVIMIENTO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(FormTareaMovimiento))
